import {Inertia} from '@inertiajs/inertia';
import cx from 'classnames';
import React, {useState} from 'react';

import {Button, ButtonSize, ButtonType} from '../../components/crousal/Button';
import {H1} from '../../components/crousal/Headings';
import {TextInput} from '../../components/crousal/TextInput';
import {FlashMessage} from '../../components/FlashMessage';
import styled from "styled-components";

const ForgotPasswordBackgroundImage = styled.div`
 background: url('/images/unrankedsmurfs-login/mobile_loginbg.png');
 background-size: cover;

@media (min-width: 1024px) {
  background: url('/images/unrankedsmurfs-login/login_bg.png');
  background-size: cover;
  }
`;

interface IProps {
    errors: Record<'email' | 'password', string>;
    oldInput: Record<'email' | 'password', string>;
}

export function ForgotPassword({errors, oldInput}: IProps) {
    const [email, setEmail] = useState(oldInput?.email ?? '');

    function handleReset() {
        Inertia.post('/forgot-password', {email});
    }

    return (
        <ForgotPasswordBackgroundImage className="h-screen">
            <div className="h-full flex relative">
                <div className={cx('w-full lg:w-3/5 bg-gray-100', 'pt-100 lg:pt-200')}>
                    <div className="w-4/5 md:w-1/2 xl:w-1/3 mx-auto mt-32">
                        <H1 className="text-smurfs-gold">Password Reset</H1>

                        <div className="font-ubuntu text-london-air-white font-bold leading-tight mt-6">
                            Don't worry, we'll send you an email with a reset link.
                        </div>

                        <FlashMessage className="mt-2 p-2 text-md"/>

                        <TextInput
                            value={email}
                            onChange={setEmail}
                            onEnter={handleReset}
                            placeholder={"Email"}
                            className="mt-6"
                            error={errors.email}
                        />

                        <div className="flex mt-6">
                            <Button type={ButtonType.DEFAULT} size={ButtonSize.DEFAULT} onClick={handleReset}>
                                Reset
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </ForgotPasswordBackgroundImage>
    );
}
